import { fetchCabasEstimateById, type CabasEstimateDetail } from '@/services/cabas'
import { useQuery } from '@tanstack/react-query'

export const useCabasEstimate = (id?: string) => {
  return useQuery<CabasEstimateDetail | null>({
    queryKey: ['cabas-estimate', id],
    queryFn: async () => {
      if (!id) return null
      return fetchCabasEstimateById(id)
    },
    enabled: Boolean(id),
  })
}
